/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AttachmentIcon = /*#__PURE__*/ createSvgIcon(
  'AttachmentIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M14.5 13.5c0 1.248-.438 2.31-1.314 3.186C12.31 17.562 11.248 18 10 18c-1.264 0-2.33-.455-3.198-1.365-.868-.91-1.302-2.003-1.302-3.28V5.25c0-.903.316-1.67.948-2.302C7.08 2.316 7.848 2 8.75 2c.917 0 1.688.333 2.313 1 .624.667.937 1.465.937 2.396V13a1.93 1.93 0 01-.582 1.418A1.93 1.93 0 0110 15c-.57 0-1.045-.202-1.427-.606C8.19 13.99 8 13.498 8 12.917V5.75c0-.213.071-.39.214-.534A.72.72 0 018.746 5c.21 0 .39.072.535.216a.72.72 0 01.219.534V13a.486.486 0 00.5.5.485.485 0 00.5-.5V5.25c0-.486-.17-.9-.51-1.24-.34-.34-.755-.51-1.244-.51s-.902.177-1.24.531A1.765 1.765 0 007 5.291V13.5c0 .833.292 1.538.875 2.115A2.986 2.986 0 0010 16.5c.833.014 1.542-.285 2.125-.896.583-.61.875-1.347.875-2.208V5.75c0-.213.072-.39.214-.534A.72.72 0 0113.746 5c.21 0 .39.072.535.216a.72.72 0 01.219.534v7.75z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default AttachmentIcon;
